module.exports = __webpack_public_path__ + "img/fvckrender.989d8387.png";